import VueComponent from 'vue';

export default interface Validator {
    isValid: boolean | null;
    errors: string[];
}

export function handleValidationErrors(vue: VueComponent, errors: string[], validator: Validator): void {
    validator.errors = [];
    validator.isValid = null;

    if (errors) {
        errors.forEach((msg: string) => validator.errors.push(vue.$t(msg) as string));
        validator.isValid = validator.errors.length == 0;
    }
}
